import React, { useState } from 'react'
import {
    AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay,
    Button
} from '@chakra-ui/react'
import { useConfirmationModalStore } from '../../store/modalsStore'

function ConfirmationModal({isOpen, onClose}) {
    const cancelRef = React.useRef()
    const [isLoading, setIsLoading] = useState(false)
    const state = useConfirmationModalStore(state => state.state)

    const onBtn = async () => {
        setIsLoading(true)
        await state.func(...state.args)
        setIsLoading(false)
        onClose()
    }

    return (
        <AlertDialog
            isOpen={isOpen}
            onClose={onClose}
            leastDestructiveRef={cancelRef}
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader>{state.title}</AlertDialogHeader>
                    <AlertDialogCloseButton />
                    <AlertDialogBody>{state.question}</AlertDialogBody>
                    <AlertDialogFooter>
                        <Button
                            ref={cancelRef}
                            onClick={onClose}
                            mr='var(--default-gap)'
                            variant='secondary'
                        >
                            Отмена
                        </Button>
                        <Button onClick={onBtn} isLoading={isLoading}>
                            {state.btnText}
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}

export default ConfirmationModal
